import moment from "moment";
import "moment/locale/pt-br";
import "bootstrap-daterangepicker/daterangepicker.css";
import MomentUtils from "@date-io/moment";
import ThemeProvider from "contexts/Theme";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import Layout from "app/tracking-layout/TrackingLayout";
import { Provider } from "react-redux";
import "./App.css";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import { msalConfig } from "./auth/useAuth";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import ProviAuth from "./auth";
import UserSetup from "./user-setup/userSetup";

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <MuiPickersUtilsProvider
          libInstance={moment}
          utils={MomentUtils}
          locale="pt-br"
        >
          <ProviAuth>
            <UserSetup>
              <BrowserRouter>
                <ThemeProvider>
                  <Layout />
                </ThemeProvider>
              </BrowserRouter>
            </UserSetup>
          </ProviAuth>
        </MuiPickersUtilsProvider>
      </Provider>
    </MsalProvider>
  );
}

export default App;
